import React, { useEffect, useState } from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneLight } from "react-syntax-highlighter/dist/esm/styles/prism";
import CopyImage from "../assets/images/icon-copy.png"; 
import NoResult from "./NoResult";
import "../assets/css/Info.css";
import { timeOutAlert } from "../utils/comm";

const Info = ({searchValue}) => {
  const [groupedData, setGroupedData] = useState({});

  // 조회 결과 data 변경시 발생 이벤트
  useEffect(() => {
    try {

      // item의 ARTCL_CD기준으로 그룹화
      const grouped = searchValue.reduce((acc, item) => {
        const key = item.ARTCL_CD;
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

      const sortedArtclCds = Object.keys(grouped).sort((a, b) => {
          // 문자열 ARTCL_CD를 올바르게 비교하기 위해 localeCompare 사용
          return a.localeCompare(b);
      });

      const sortedItemsArrays = sortedArtclCds.map(ARTCL_CD => {
          return grouped[ARTCL_CD];
      });
      
      setGroupedData(sortedItemsArrays);
    } catch (error) {
      console.error("Error:", error);
    }
  }, [searchValue]);

  // 복사버튼 이벤트
  const handleCopy = async (text) => {
    navigator.clipboard.writeText(text)
      .then(async() => {
        await timeOutAlert({body : "복사되었습니다!", timeOut : 0.7});
      })
      .catch((err) => {
        console.error('복사 실패:', err);
      });
  };

  const isEmpty = Object.keys(groupedData).length === 0; // 로딩 끝난 후에만 empty 판정

  return (
    <div>
      { isEmpty ? (
        <NoResult listData={[]} />
      ) : (
        Object.entries(groupedData).map(([ARTCL_CD, items]) => (
          <div key={ARTCL_CD} className="card" id={items[0]?.ARTCL_NM}>
            <div style={{ padding: '12px 0' }}>
              <h3 className="title">{items[0]?.ARTCL_NM || "제목 없음"}</h3>
              <span>{items[0]?.ARTCL_EXPLN}</span>
            </div>
            <div className="example-box">
              <div style={{display : "flex", justifyContent : "space-between"}}>
              <div className="example-label">EXAMPLE CODE</div>
              <span
                onClick={() => handleCopy(items[0]?.ARTCL_EXAMPLE_CD || "")}
                style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}
              > 
                <img 
                  src={CopyImage}
                  alt="복사하기" 
                  style={{ width: '20px', height: '20px' }} 
                />복사
              </span>
              </div>
              <SyntaxHighlighter
                language="jsx"
                style={oneLight}
                customStyle={{
                  backgroundColor: "transparent",
                  padding: "0",
                  margin: "0",
                  fontSize: "0.875rem",
                  lineHeight: "1.6",
                  overflowX: "auto"
                }}
                codeTagProps={{ style: { backgroundColor: "transparent" } }}
              >
                {items[0]?.ARTCL_EXAMPLE_CD || ""}
              </SyntaxHighlighter>
            </div>

            <table style={{ tableLayout: 'fixed', width: '100%' }}>
              <thead>
                <tr>
                  <th style={{ width: '28%' }}>Prop</th>
                  <th style={{ width: '12%' }}>Type</th>
                  <th style={{ width: '45%' }}>Description</th>
                  <th style={{ width: '15%' }}>Parameter</th>
                </tr>
              </thead>
              <tbody>
                {items.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row.ATRB_NM}</td>
                    <td>{row.ATRB_TYPE}</td>
                    <td style={{ textAlign: 'left', overflowWrap: 'break-word' }}>{row.ATRB_EXPLN}</td>
                    <td>{row.ATRB_EXAMPLE_VL}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))
      )}
    </div>
  );
};

export default Info;